module.exports = __webpack_public_path__ + "static/img/SB.21e850ab.svg";